"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConditionalAnchor = void 0;
var _react = _interopRequireDefault(require("react"));
var _ConditionalAnchor = require("./styles/ConditionalAnchor");
var _propTypes = _interopRequireDefault(require("prop-types"));
const ConditionalAnchor = ({
  children,
  linkUrl,
  underlined = true,
  dataTestid,
  className
}) => linkUrl ? /*#__PURE__*/_react.default.createElement(_ConditionalAnchor.StyledAnchor, {
  className: className,
  href: linkUrl,
  underlined: underlined,
  "data-testid": dataTestid
}, /*#__PURE__*/_react.default.createElement("span", null, children)) : children;
exports.ConditionalAnchor = ConditionalAnchor;
ConditionalAnchor.propTypes = {
  children: _propTypes.default.node,
  className: _propTypes.default.string,
  linkUrl: _propTypes.default.string,
  underlined: _propTypes.default.bool,
  dataTestid: _propTypes.default.string
};